import {create} from "zustand";

interface IAlert {
    uid:string,
    type: "success" | "danger" | "warning",
    message:string
}

interface IAlertStore {
    alerts: IAlert[],
    addAlert: (alert:IAlert,showTime:number)=>void
    removeAlert: (uid:string)=>void
}

const useAlertStore = create<IAlertStore>((set)=>(
    {
        alerts:[],
        addAlert : (alert,showTime=500)=>{
            const alerts = [...useAlertStore.getState().alerts];
            alerts.push(alert);
            set({alerts});
            setTimeout(()=>{
                useAlertStore.getState().removeAlert(alert.uid);
            },showTime)
        },
        removeAlert : uid => {
            let alerts = [...useAlertStore.getState().alerts];
            const index = alerts.findIndex((x)=>x.uid == uid);
            alerts.splice(index,1);
            set({alerts:alerts});
        }

    }
))

export default useAlertStore